import localConfig from '../../../localConfig';

const { RECAPTCHA_API_KEY, GOOGLE_ANALYTICS_TID, GOOGLE_MAPS_API_KEY } = localConfig.apiKeys;

export {
    RECAPTCHA_API_KEY,
    GOOGLE_ANALYTICS_TID,
    GOOGLE_MAPS_API_KEY
}